import {
  CustomFieldStatus,
  CustomFieldType,
  TargetEntityType,
} from "@/shared/domain/customFields";

// Each map below is keyed by its full enum, so a new enum member is a compile
// error until its presentation is filled in.

const TYPE_LABELS: Record<CustomFieldType, string> = {
  [CustomFieldType.String]: "String",
  [CustomFieldType.Number]: "Number",
  [CustomFieldType.Timestamp]: "Timestamp",
  [CustomFieldType.Boolean]: "Boolean",
  [CustomFieldType.Enum]: "Enum",
};

export function customFieldTypeLabel(type: CustomFieldType): string {
  return TYPE_LABELS[type];
}

/** Singular capitalized noun for an entity type, e.g. for the create dialog title. */
const ENTITY_TYPE_LABELS: Record<TargetEntityType, string> = {
  [TargetEntityType.Collection]: "Collection",
  [TargetEntityType.Dataset]: "Dataset",
  [TargetEntityType.Device]: "Device",
  [TargetEntityType.Event]: "Event",
  [TargetEntityType.Session]: "Session",
};

export function customFieldEntityTypeLabel(
  entityType: TargetEntityType,
): string {
  return ENTITY_TYPE_LABELS[entityType];
}

/**
 * Whether a field can be edited. Only `Ready` fields qualify — this matches the
 * backend update guard (it updates `WHERE status = 'ready'`), so editing a
 * Creating/Deleting/Failed field would be rejected server-side.
 */
export function isCustomFieldEditable(status: CustomFieldStatus): boolean {
  return status === CustomFieldStatus.Ready;
}
